<template>
  <div class="block sm:hidden">
    <button class="shadow border-2 fixed circle-home" @click="scrollToMe">
      <img
        v-if="isArrowUp === false"
        :src="require('../assets/home/arrowdown.png')"
      />
      <img v-else :src="require('../assets/home/arrowup.png')" />
    </button>
    <p class="fixed text-white text-home">{{ anchorValue }}</p>
  </div>

  <vue-final-modal
    v-model="showModal"
    name="discount"
    class="m-auto w-1/2 h-1/2 bg-white sm:w-4/5 sm:h-4/5 modal-h"
    overlayClass="whitewhite"
    data-aos="zoom-in"
    :lock-scroll="true"
  >
    <button class="modal__close modal-close-button" @click="showModal = false">
      <mdi-close>X</mdi-close>
    </button>
    <div class="modal_content m-auto text-center py-20 px-8 sm:py-10">
      <span class="modal__title bg-white">takeout discount</span>
      <div class="modal__content bg-white p-12 flex sm:p-0 sm:flex-col">
        <div class="w-1/3 sm:w-full">
          <img
            :src="require('../assets/home/popup.jpg')"
            class="sm:m-auto sm:pt-8"
            alt=""
          />
        </div>
        <div class="w-2/3 pt-11 pl-4 sm:w-full">
          <p class="modal-p text-left sm:text-center sm:pb-8">
            Togo 15% off on Pickup.
          </p>
        </div>
      </div>
      <a href="https://sushishogun.zomi.menu/" target="_blank">
      <button class="bg-red-500 text-white px-20 sm:px-10 py-4 modal-order-now">
        ORDER NOW
      </button>
      </a>
    </div>
  </vue-final-modal>

  <parallax-big-image ref="home"></parallax-big-image>
  <brand-story ref="brand-story" class="overflow-hidden"></brand-story>
  <scroll-panaroma ref="shogun"></scroll-panaroma>
  <shogun-fly-in ref="why-us" class="overflow-hidden"></shogun-fly-in>
  <Years ref="experience" class="overflow-hidden"></Years>
  <featured-carousel
    ref="featured-dishes"
    class="overflow-hidden"
  ></featured-carousel>
</template>

<script>
import ParallaxBigImage from "../components/ParallaxBigImage";
import ScrollPanaroma from "../components/ScrollPanaroma";
import ShogunFlyIn from "../components/ShogunFlyIn";
import FeaturedCarousel from "../components/FeaturedCarousel";
import Years from "../components/Years";
import BrandStory from "../components/BrandStory";
import _ from "lodash";

export default {
  data() {
    return {
      els: [
        "home",
        "brand-story",
        "shogun",
        "why-us",
        "experience",
        "featured-dishes"
      ],
      offsetY: 0,
      position: 0,
      showModal: true,
      homeEl: "",
      brandStoryEl: "",
      shogunEl: "",
      whyUsEl: "",
      experienceEl: "",
      featuredDishEl: "",
      count: 0,
      isArrowUp: false
    };
  },
  computed: {
    anchorValue() {
      if (this.position == 5) {
        //return this.els[0].replace(/-/g, "").toUpperCase();
        return "";
      } else {
        return this.els[this.position + 1].replace(/-/g, "").toUpperCase();
      }
    }
  },

  methods: {
    scrollToMe() {
      this.count++;
      this.isArrowUp = false;

      if (this.position == 5) {
        this.position = 0;
        this.isArrowUp == false;
      } else {
        this.position++;
        if (this.position == 5) {
          this.isArrowUp = true;
        }
      }
      //console.log("click" + this.count +"upto dishes" +(this.whyUsEl.offsetHeight +this.homeEl.offsetHeight +this.brandStoryEl.offsetHeight + this.featuredDishEl +this.shogunEl.offsetHeight + window.innerHeight) +  "position" + this.position);

      let el = this.$refs[this.els[this.position]].$el;
      const top = el.offsetTop;

      window.scrollTo(0, top);

      console.log(top);
    },
    handleScroll() {
      console.log(window.scrollY);

      this.setPosition();
      console.log(this.position);
    },
    setPosition() {
      this.offsetY = window.scrollY;
      this.isArrowUp = false;
      if (
        this.offsetY >= 0 &&
        this.offsetY < this.homeEl.offsetHeight - window.innerHeight
      ) {
        this.position = 0;
      } else if (
        this.offsetY >= this.homeEl.offsetHeight - window.innerHeight &&
        this.offsetY <
          this.homeEl.offsetHeight +
            this.brandStoryEl.offsetHeight -
            window.innerHeight
      ) {
        this.position = 1;
      } else if (
        this.offsetY >=
          this.homeEl.offsetHeight +
            this.brandStoryEl.offsetHeight -
            window.innerHeight &&
        this.offsetY <
          this.brandStoryEl.offsetHeight +
            this.homeEl.offsetHeight +
            this.shogunEl.offsetHeight -
            window.innerHeight
      ) {
        this.position = 2;
      } else if (
        this.offsetY >=
          this.brandStoryEl.offsetHeight +
            this.homeEl.offsetHeight +
            this.shogunEl.offsetHeight -
            window.innerHeight &&
        this.offsetY <
          this.homeEl.offsetHeight +
            this.brandStoryEl.offsetHeight +
            this.shogunEl.offsetHeight +
            this.whyUsEl.offsetHeight -
            window.innerHeight
      ) {
        this.position = 3;
      } else if (
        this.offsetY >=
          this.homeEl.offsetHeight +
            this.brandStoryEl.offsetHeight +
            this.shogunEl.offsetHeight +
            this.whyUsEl.offsetHeight -
            window.innerHeight &&
        this.offsetY <
          this.whyUsEl.offsetHeight +
            this.homeEl.offsetHeight +
            this.brandStoryEl.offsetHeight +
            this.featuredDishEl.offsetHeight +
            this.shogunEl.offsetHeight
      ) {
        this.position = 4;
      } else {
        this.position = 5;
        this.isArrowUp = true;
      }
    }
  },

  components: {
    ParallaxBigImage,
    ScrollPanaroma,
    FeaturedCarousel,
    ShogunFlyIn,
    BrandStory,
    Years
  },
  created() {
    //window event will overwrite the scroll in individual component
    window.addEventListener("scroll", _.throttle(this.handleScroll, 300));
  },
  mounted() {
    this.setPosition();
    this.$vfm.show("discount");
    this.homeEl = this.$refs[this.els[0]].$el;
    this.brandStoryEl = this.$refs[this.els[1]].$el;
    this.shogunEl = this.$refs[this.els[2]].$el;
    this.whyUsEl = this.$refs[this.els[3]].$el;
    this.experienceEl = this.$refs[this.els[4]].$el;
    this.featuredDishEl = this.$refs[this.els[5]].$el;
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style>
body {
  padding-right: 0px !important;
  overflow: visible !important;
}
.circle-home img {
  margin: auto;
}
[data-aos^="zoom"].aos-animate {
  opacity: 1;
  transform: translateZ(0) scale(1);
}
[data-aos^="zoom"] {
  opacity: 0;
  transition-property: opacity, transform;
}
[data-aos="zoom-in"] {
  transform: scale(0.6);
}
[data-aos-duration="1000"][data-aos] {
  transition-duration: 1s;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

.whitewhite {
  background-color: white !important;
}
.modal__title {
  font-family: Times;
  font-style: normal;
  font-weight: normal;
  font-size: 2rem;
  line-height: 2rem;
  /* or 109% */

  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  /* black */

  color: #000000;
}
.modal-h {
  min-height: 500px;
}
.modal-p {
  font-family: avenirLight;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 24px;
  /* or 133% */

  letter-spacing: 0.02em;

  /* black */

  color: #000000;
}
.modal-order-now {
  font-family: Times;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 18px;
  /* identical to box height, or 100% */

  text-align: center;
  letter-spacing: 0.02em;

  color: #ffffff;
}
.modal-close-button {
  width: 30px;
  height: 30px;
  color: white;
  background-color: #c4c4c4;
  border-radius: 50%;
  margin: 1rem;
}
.circle-home {
  width: 5rem;
  height: 5rem;
  line-height: 2.75rem;
  border-radius: 50%;
  font-size: 1rem;
  color: #fff;
  text-align: center;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
}

.text-home {
  width: 100%;
  height: 4.75rem;
  color: #fff;
  text-align: right;
  position: fixed;
  right: 8rem;
  bottom: 0px;
  z-index: 9999;
  font-family: Times;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 36px;
  /* identical to box height, or 225% */

  letter-spacing: 0.05em;
  text-transform: uppercase;
}
</style>